<script>
import CsnuListVue from 'Modules/contacard/shortlist/components/CsnuList.vue';

export default {
  name: 'AnalysisCsnuList',
  extends: CsnuListVue,
};
</script>
